import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Providers } from "./lib/store";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import OrderDetail from "./pages/OrderDetail";
import { Login, Register, Forgot, Reset } from "./pages/Auth";
import Account from "./pages/Account";
import Vouchers from "./pages/Vouchers";
import ContentPage from "./pages/ContentPage";
import Contact from "./pages/Contact";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import AdminApp from "./admin/AdminApp";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

const PAGES = [
  ["/jak-nakoupit", "how_to_buy", "Jak nakoupit"],
  ["/reklamace", "complaints_page", "Reklamace"],
  ["/obchodni-podminky", "legal.terms", "Obchodní podmínky"],
  ["/gdpr", "legal.gdpr", "Ochrana osobních údajů"],
  ["/cookies", "legal.cookies", "Zásady cookies"],
];

export default function App() {
  return (
    <Providers>
      <BrowserRouter>
        <ScrollTop />
        <Loader />
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/eshop" element={<Shop />} />
            <Route path="/kategorie/:slug" element={<Shop />} />
            <Route path="/produkt/:slug" element={<ProductDetail />} />
            <Route path="/kosik" element={<Cart />} />
            <Route path="/objednavka/:id" element={<OrderDetail />} />
            <Route path="/prihlaseni" element={<Login />} />
            <Route path="/registrace" element={<Register />} />
            <Route path="/zapomenute-heslo" element={<Forgot />} />
            <Route path="/reset-hesla" element={<Reset />} />
            <Route path="/ucet" element={<Account />} />
            <Route path="/darkove-poukazy" element={<Vouchers />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/jak-to-funguje" element={<HowItWorks />} />
            <Route path="/o-nas" element={<About />} />
            {PAGES.map(([path, key, title]) => (
              <Route key={path} path={path} element={<ContentPage textKey={key} title={title} />} />
            ))}
            <Route path="*" element={<ContentPage notFound title="Stránka nenalezena" />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </Providers>
  );
}
